import axios from "axios";
import HandleLogout from "./logout";

const handleAxiosResponse = (response) => {
  if (response?.status === 401) {
    HandleLogout();
  }

  return response;
};

const getApiUrl = (endpoint) => {
  const baseUrl = (process.env.REACT_APP_API_URL || "").trim().replace(/\/+$/, "");
  const cleanEndpoint = String(endpoint || "").replace(/^\/+/, "");
  return `${baseUrl}/${cleanEndpoint}`;
};

export const AxiosGetMethod = async (endpoint, unauthorised) => {
  let headers = {};
  if (!unauthorised) {
    const token = localStorage.getItem("dwt-cust-tok");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  return await axios
    .get(getApiUrl(endpoint), {
      headers,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return handleAxiosResponse(err.response);
    });
};

export const AxiosPostMethod = async (
  endpoint,
  body,
  unauthorised,
  formData
) => {
  // body = await geturlsearchbody(body);
  let headers = {};
  if (!unauthorised) {
    const token =
      localStorage.getItem("dwt-cust-tok") || localStorage.getItem("dwt-tok-otp");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  if (formData) {
    headers = {
      ...headers,
      ...{
        "Content-Type": "multipart/form-data",
      },
    };
  }
  return await axios
    .post(getApiUrl(endpoint), body, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return handleAxiosResponse(err.response);
    });
};

export const AxiosPutMethod = async (endpoint, body, unauthorised, formData) => {
  // body = await geturlsearchbody(body);
  let headers = {};
  if (!unauthorised) {
    const token = localStorage.getItem("dwt-cust-tok");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  if (formData) {
    headers = {
      ...headers,
      ...{
        "Content-Type": "multipart/form-data",
      },
    };
  }
  return await axios
    .put(getApiUrl(endpoint), body, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return handleAxiosResponse(err.response);
    });
};

export const AxiosDeleteMethod = async (endpoint, body) => {
  // body = await geturlsearchbody(body);
  const token = localStorage.getItem("dwt-cust-tok");
  return await axios
    .delete(getApiUrl(endpoint), {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return handleAxiosResponse(err.response);
    });
};
